import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getRevenueCountriesData } from "../../../../services/event/dashboard/dashboardServices";

const RevenueCountryChart = (props) => {
  const { startMonth, endMonth, subDomain ,filterField} = props;

  const [chartData, setChartData] = useState({
    series: [
      {
        name: "",
        data: [],
        color: "#00E396", //green
      },
    ],
    options: {},
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRevenueCountriesData({
          sub_domain: subDomain,
          filterField: filterField,fromDate: startMonth, toDate: endMonth  
        });
        console.log("Response data:", response); // Log the response data
        const countries = response?.data.map((item) => item.country);
        const counts = response?.data.map((item) => parseInt(item.count));
        setChartData((prevData) => ({
          ...prevData,
          series: [{ name: "series-1", data: counts }],
          options: {
            ...prevData.options,
            xaxis: {
              categories: countries,
            },
            chart: {
              type: "bar",
              height: "100%",
              width: "100%",
            },
            title: {
              ...prevData.options.title,
              text: `Total Revenue Country: ${counts.reduce(
                (a, b) => a + b,
                0
              )}`,
              align: "left",
              style: {
                fontSize: "16px",
                fontWeight: 800,
                color: "#333",
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
                borderRadius: 3,
              },
            },
            dataLabels: {
              enabled: false,
            },
          },
        }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [subDomain,startMonth,endMonth,filterField]);

  return (
    <>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </>
  );
};

export default RevenueCountryChart;
